import { array, InferType, number, object, string } from "yup";
import { OutcomeSchema } from ".";

export const ConditionsSchema = object({
  zero_to_three_years_since_offense_outcome: OutcomeSchema.required(),
  three_to_ten_years_since_offense_outcome: OutcomeSchema.required(),
  ten_or_more_years_since_offense_outcome: OutcomeSchema.required(),
});

export const CodeSchema = object({
  code: string().required(),
  global_outcome: OutcomeSchema.required(),
  one_offense: ConditionsSchema.required(),
  two_or_more_offenses: ConditionsSchema.required(),
});

export const CategorySchema = object({
  category: string().required(),
  codes: array().of(CodeSchema.required()).required(),
});

export const BasicCanadianCriminalRecordCriteriaSchemaV1 = object({
  version: number().required(),
  ruleset: array().of(CategorySchema.required()).required(),
});

export function isValidBasicCanadianCriminalRecordCriteria(
  criteria: unknown
): criteria is InferType<typeof BasicCanadianCriminalRecordCriteriaSchemaV1> {
  try {
    BasicCanadianCriminalRecordCriteriaSchemaV1.validateSync(criteria);
    return true;
  } catch (error) {
    console.error("Invalid Basic Canadian Criminal Record Criteria:", error);
    return false;
  }
}

// Export inferred types from schemas
export type Conditions = InferType<typeof ConditionsSchema>;
export type Code = InferType<typeof CodeSchema>;
export type Category = InferType<typeof CategorySchema> & {
  set?: boolean;
};
